<template>
    <div>
        <div class="ribbon" id="ribbon">
            <span>Not sure where to start?</span>
            <a href="https://wa.me/2349160002370" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path
                        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z">
                    </path>
                </svg>
                Chat with us
            </a>

        </div>

        <nav>
            <router-link to="/" class="nav-logo">
                <img src="@/assets/full_logo.svg" alt="Succour Logo" class="logo-img">
            </router-link>


            <ul class="nav-links">
                <li><router-link to="/about-us">About</router-link></li>
                <li><router-link to="/caregiver-list">Caregivers</router-link></li>
                <li><router-link to="/faq">FAQ</router-link></li>
            </ul>
            <div class="nav-ctas">
                <router-link to="/contact-us" class="btn-ghost">Contact Us</router-link>
                <router-link to="/login" class="btn-ghost">Log In</router-link>
                <div class="aud-cta"><router-link to="/caregiver-list" class="btn-primary">Get Care</router-link></div>
            </div>
        </nav>

        <slot></slot>
        <!-- FOOTER -->
        <footer>
            <div class="footer-grid">
                <div>
                    <div style="display:flex;align-items:center;gap:8px;">
                        <img src="@/assets/white_logo.svg" alt="Succour Logo" class="footer-logo-img" />
                    </div>
                    <p class="footer-tagline">Succour helps families connect with verified caregivers faster.</p>
                    <div class="footer-socials">
                        <!-- LinkedIn -->
                        <a href="#" class="social-btn" title="LinkedIn">
                            <svg viewBox="0 0 24 24">
                                <path
                                    d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                            </svg>
                        </a>
                        <!-- Facebook -->
                        <a href="#" class="social-btn" title="Facebook">
                            <svg viewBox="0 0 24 24">
                                <path
                                    d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                            </svg>
                        </a>
                        <!-- Instagram -->
                        <a href="#" class="social-btn" title="Instagram">
                            <svg viewBox="0 0 24 24">
                                <path
                                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                            </svg>
                        </a>
                        <!-- X / Twitter -->
                        <a href="#" class="social-btn" title="X (Twitter)">
                            <svg viewBox="0 0 24 24">
                                <path
                                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="footer-col">
                    <!-- <h4>Company</h4> -->
                    <ul>
                        <li><router-link to="/about-us">About Us</router-link></li>
                        <li><router-link to="/faq">FAQ</router-link></li>
                        <li><router-link to="/terms-of-use">Terms of Use</router-link></li>
                        <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
                    </ul>
                </div>
                <div class="footer-col">
                    <!-- <h4>Join Us</h4> -->
                    <ul>
                        <li><router-link to="/caregiver-list">Apply to Care Jobs</router-link></li>
                        <li></li>
                        <li><router-link to="/contact-us">Contact Us</router-link></li>
                        <li><a href="/cdn-cgi/l/email-protection#5231213112212731313d27207c31332037"
                                style="color:inherit;"><span class="__cf_email__"
                                    data-cfemail="a5c6d6c6e5d6d0c6c6cad0d78bc6c4d7c0">[email&#160;protected]</span></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer-bottom">
                <p>© 2026 Succour Company S.L.L. All rights reserved.</p>
                <p>Built with Care 🌿</p>
            </div>
        </footer>

    </div>

</template>


<style lang="css">
:root {
    --pink: #F59CAB;
    --pink-light: #FDE8EC;
    --pink-mid: #F8C4CC;
    --green: #17865F;
    --green-dark: #0f5c41;
    --green-light: #E8F5EF;
    --cream: #FDF9F7;
    --orange: #FF9700;
    --text-dark: #1C2B27;
    --text-mid: #4A5E58;
    --text-light: #8A9E98;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    font-family: 'Open Sans', sans-serif;
    background: #F3F6F5;
    color: var(--text-dark);
    overflow-x: hidden;
}

/* RIBBON */
.ribbon {
    background: var(--green);
    color: white;
    padding: 9px 20px;
    font-size: .82rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}


.ribbon a {
    background: white;
    color: var(--green);
    padding: 5px 16px;
    border-radius: 100px;
    font-weight: 700;
    font-size: .8rem;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: background .2s, color .2s;
}

.ribbon a:hover {
    background: var(--pink);
    color: white;
}


/* NAV */
nav {


    background: rgba(253, 249, 247, .97);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid rgba(245, 156, 171, .12);
    padding: 0 6%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
}

.nav-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
}

.logo-img {
    width: 30%;
    object-fit: contain;
}

.logo-text {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.35rem;
    font-weight: 700;
    color: var(--text-dark);
}

.logo-text sup {
    font-size: .5rem;
    color: var(--text-light);
    font-weight: 400;
}

.nav-links {
    display: flex;
    align-items: center;
    gap: 28px;
    list-style: none;
}

.nav-links a {
    font-size: .85rem;
    color: var(--text-mid);
    text-decoration: none;
    font-weight: 400;
    transition: color .2s;
}

.nav-links a:hover {
    color: var(--green);
}

.nav-ctas {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-ghost {
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    color: var(--text-mid);
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px 14px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 400;
    transition: color .2s;
}

.btn-ghost:hover {
    color: var(--green);
}

.btn-primary {
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    font-weight: 700;
    background: var(--pink);
    color: white;
    border: none;
    padding: 10px 22px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    transition: background .2s, transform .15s;
}

.btn-primary:hover {
    background: #e8849a;
    transform: translateY(-1px);
}

.btn-green {
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    background: var(--green);
    color: white;
    border: none;
    padding: 13px 32px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: background .2s, transform .15s;
}

.btn-green:hover {
    background: var(--green-dark);
    transform: translateY(-1px);
}

.btn-outline-green {
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    background: transparent;
    color: var(--green);
    border: 2px solid var(--green);
    padding: 11px 28px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: background .2s, color .2s;
}

.btn-outline-green:hover {
    background: var(--green);
    color: white;
}

/* Animations */
@keyframes fadeUp {
    from {
        opacity: 0;
        transform: translateY(22px)
    }

    to {
        opacity: 1;
        transform: translateY(0)
    }
}

.hero-content>* {
    animation: fadeUp .7s ease both;
}

.hero-content>*:nth-child(1) {
    animation-delay: .1s;
}

.hero-content>*:nth-child(2) {
    animation-delay: .22s;
}

.hero-content>*:nth-child(3) {
    animation-delay: .34s;
}

.hero-content>*:nth-child(4) {
    animation-delay: .46s;
}

/* RESPONSIVE */
.service-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.cg-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
}

.audience-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
    margin-top: 50px;
}

.testi-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 50px;
}

.footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 48px;
    margin-bottom: 56px;
}

.footer-logo-img {
    width: 28%;
    object-fit: contain;
}

.why {
    padding: 90px 7%;
    background: var(--cream);
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 56px;
    align-items: center;
}


footer {
    background: var(--text-dark);
    padding: 68px 7% 30px;
}

.footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 48px;
    margin-bottom: 56px;
}

.footer-logo-text {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.3rem;
    font-weight: 700;
    color: white;
}

.footer-logo {
    display: flex;
    align-items: center;
    gap: 8px;
}



.footer-logo-text sup {
    font-size: .48rem;
    color: rgba(255, 255, 255, .3);
    font-weight: 400;
}

.footer-tagline {
    font-size: .83rem;
    color: rgba(255, 255, 255, .42);
    line-height: 1.7;
    margin: 14px 0 22px;
    font-weight: 300;
    max-width: 230px;
}

.footer-socials {
    display: flex;
    gap: 10px;
}

.social-btn {
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, .07);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: background .2s, color .2s;
}

.social-btn:hover {
    background: var(--pink);
}

.social-btn svg {
    width: 16px;
    height: 16px;
    fill: rgba(255, 255, 255, .55);
    transition: fill .2s;
}

.social-btn:hover svg {
    fill: white;
}

.footer-col h4 {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, .35);
    margin-bottom: 18px;
}

.footer-col ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer-col a {
    font-size: .85rem;
    color: rgba(255, 255, 255, .55);
    text-decoration: none;
    font-weight: 300;
    transition: color .2s;
}

.footer-col a:hover {
    color: var(--pink);
}

.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, .07);
    padding-top: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.footer-bottom p {
    font-size: .76rem;
    color: rgba(255, 255, 255, .25);
    font-weight: 300;
}


/* ── CARER MODAL ── */
.cg-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .45);
    z-index: 3000;
    display: none;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.cg-modal-overlay.open {
    display: flex;
}

.cg-modal {
    background: white;
    border-radius: 20px;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, .18);
    overflow: hidden;
    animation: modalIn .25s ease;
}

@keyframes modalIn {
    from {
        opacity: 0;
        transform: translateY(16px)
    }

    to {
        opacity: 1;
        transform: translateY(0)
    }
}

.cg-modal-header {
    padding: 22px 22px 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, .07);
}

.cg-modal-avatar {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eee;
}

.cg-modal-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}

.cg-modal-name {
    font-family: 'Open Sans', sans-serif;
    font-size: 1rem;
    font-weight: 700;
    color: #1C2B27;
    display: flex;
    align-items: center;
    gap: 6px;
}

.cg-modal-name span {
    width: 18px;
    height: 18px;
    background: #17865F;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: .6rem;
    color: white;
}

.cg-modal-role {
    font-size: .78rem;
    color: #4A5E58;
    font-weight: 300;
    margin-top: 2px;
}

.cg-modal-close {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1.5px solid rgba(0, 0, 0, .12);
    background: white;
    cursor: pointer;
    font-size: .85rem;
    color: #4A5E58;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background .2s;
}

.cg-modal-close:hover {
    background: #FDE8EC;
}

.cg-modal-body {
    padding: 18px 22px 22px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.cg-modal-wa {
    display: block;
    background: #F59CAB;
    color: white;
    text-align: center;
    padding: 11px;
    border-radius: 100px;
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    font-weight: 700;
    text-decoration: none;
    margin-bottom: 4px;
    transition: background .2s;
}

.cg-modal-wa:hover {
    background: #e8849a;
}

.cg-modal-section {
    background: #F3F6F5;
    border-radius: 12px;
    padding: 14px 16px;
}

.cg-modal-section-title {
    font-size: .72rem;
    font-weight: 700;
    color: #1C2B27;
    text-transform: uppercase;
    letter-spacing: .07em;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 7px;
}

.cg-modal-section-title svg {
    width: 14px;
    height: 14px;
    stroke: #17865F;
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
}

.cg-modal-section ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.cg-modal-section ul li {
    font-size: .82rem;
    color: #4A5E58;
    font-weight: 300;
}

.cg-modal-section ul li::before {
    content: '• ';
    color: #17865F;
}

.cg-modal-section p {
    font-size: .82rem;
    color: #4A5E58;
    font-weight: 300;
}

/* ── Large tablet ≤1024px ── */
@media (max-width: 1024px) {
    .service-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .cg-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .audience-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .testi-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .footer-grid {
        grid-template-columns: 2fr 1fr 1fr;
    }

    .why {
        gap: 32px;
    }
}

/* ── Mobile ≤768px ── */
@media (max-width: 768px) {

    /* Nav */
    .nav-links {
        display: none;
    }

    .nav-ctas .btn-ghost:first-child {
        display: none;
    }

    .ribbon {
        padding: 8px 14px;
        font-size: .78rem;
    }

    /* Hero stack text then carousel */
    .hero {
        display: flex;
        flex-direction: column;
        min-height: auto;
        padding-top: 0;
        overflow: visible;
    }

    .hero::before {
        display: none;
    }

    .hero-content {
        order: 1;
        padding: 130px 6% 28px;
        background: var(--cream);
        position: relative;
        z-index: 2;
    }

    .hero h1 {
        font-size: clamp(1.8rem, 6.5vw, 2.5rem);
        line-height: 1.18;
        margin-bottom: 12px;
    }

    .hero-sub {
        font-size: .92rem;
        line-height: 1.7;
        max-width: 100%;
        margin-bottom: 22px;
    }

    .hero-ctas {
        gap: 10px;
    }

    .hero-ctas a {
        flex: 1;
        text-align: center;
        padding: 12px 14px;
        font-size: .85rem;
    }

    /* Carousel */
    .hero-visual {
        order: 2;
        display: block;
        position: relative;
        width: 100%;
        height: 480px;
        min-height: unset;
        overflow: hidden;
    }

    .hero-visual::after {
        display: none;
    }

    .carousel {
        width: 100%;
        height: 480px;
    }

    .carousel-slides {
        height: 480px;
    }

    .carousel-slide {
        height: 480px;
    }

    .carousel-slide img {
        width: 100%;
        height: 480px;
        object-fit: cover;
        object-position: center 12%;
    }

    .carousel-prev {
        left: 10px;
    }

    .carousel-next {
        right: 10px;
    }

    .carousel-dots {
        bottom: 14px;
    }

    /* Section padding reduction */
    .services {
        padding: 52px 6%;
    }

    .how {
        padding: 52px 6%;
    }

    .caregivers {
        padding: 52px 6%;
    }

    .audience {
        padding: 52px 6%;
    }

    .testimonials {
        padding: 52px 6%;
    }

    .mission {
        padding: 52px 6%;
    }

    footer {
        padding: 48px 6% 28px;
    }

    /* Section titles */
    .section-title {
        font-size: 1.4rem;
    }

    .section-sub {
        font-size: .88rem;
        margin-bottom: 28px;
    }

    /* care-header stacks on mobile */
    .care-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    /* Grids single or 2-col */
    .service-grid {
        grid-template-columns: 1fr 1fr;
        gap: 14px;
    }

    .cg-grid {
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .steps {
        grid-template-columns: 1fr;
    }

    .steps::before {
        display: none;
    }

    .why {
        grid-template-columns: 1fr;
        gap: 28px;
    }

    .why-visual {
        height: 280px;
    }

    .audience-grid {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .aud-card {
        padding: 26px 20px;
    }

    .testi-grid {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .footer-grid {
        grid-template-columns: 1fr;
        gap: 28px;
    }

    /* Caregiver card buttons */
    .cg-btn-request,
    .cg-btn-details {
        font-size: .74rem;
        padding: 9px 6px;
    }
}

/* ── Small phones ≤480px ── */
@media (max-width: 480px) {

    /* Logo Image */
    .logo-img {
        width: 80px;
        height: 80px;
        object-fit: contain;
    }

    /* Hero */
    .hero-content {
        padding-top: 150px;
        padding-left: 5%;
        padding-right: 5%;
    }

    .hero h1 {
        font-size: 1.6rem;
        line-height: 1.2;
    }

    .hero-sub {
        font-size: .86rem;
    }

    .hero-ctas {
        flex-direction: column;
    }

    .hero-ctas a {
        width: 100%;
        text-align: center;
        font-size: .84rem;
        padding: 13px 16px;
        box-sizing: border-box;
    }

    /* Carousel */
    .hero-visual {
        height: 380px;
    }

    .carousel {
        height: 380px;
    }

    .carousel-slides {
        height: 380px;
    }

    .carousel-slide {
        height: 380px;
    }

    .carousel-slide img {
        height: 380px;
        object-fit: cover;
        object-position: center 12%;
    }

    /* Section padding */
    .services {
        padding: 40px 5%;
    }

    .how {
        padding: 40px 5%;
    }

    .caregivers {
        padding: 40px 5%;
    }

    .audience {
        padding: 40px 5%;
    }

    .testimonials {
        padding: 40px 5%;
    }

    .mission {
        padding: 40px 5%;
    }

    footer {
        padding: 36px 5% 24px;
    }

    /* Titles */
    .section-title {
        font-size: 1.25rem;
    }

    .section-sub {
        font-size: .84rem;
    }

    /* Grids */
    .service-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .cg-grid {
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }

    .audience-grid {
        grid-template-columns: 1fr;
    }

    .footer-grid {
        grid-template-columns: 1fr;
    }

    /* Cards */
    .aud-card {
        padding: 22px 16px;
    }

    .testi-card {
        padding: 20px 18px;
    }

    .cg-photo {
        height: 160px;
    }

    .cg-name {
        font-size: .88rem;
    }

    .cg-role {
        font-size: .74rem;
    }

    .cg-btn-request,
    .cg-btn-details {
        font-size: .72rem;
        padding: 8px 4px;
        border-radius: 8px;
    }
}
</style>